// "670+ Files into 2,110 Vector Chunks on a Budget VPS" — Sync Engine short.
// Cold Compute / Neon kit. ~134s @ 30fps. Grounded in EAKC-MVP src/lib/jobs/sync-worker.ts.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  every sync died at exactly 20%
  pipeline: { start: 150, duration: 540 }, //  0:05–0:23  the 5-step pipeline; step 3 is the cliff
  cause: { start: 690, duration: 600 }, //     0:23–0:43  mutual recursion → stack overflow
  fix: { start: 1290, duration: 540 }, //      0:43–1:01  one-line fix: call the function that does less
  memory: { start: 1830, duration: 540 }, //   1:01–1:19  for-loop vs .map() + Semaphore
  constants: { start: 2370, duration: 600 }, //1:19–1:39  every magic number earned from a failure
  payoff: { start: 2970, duration: 540 }, //   1:39–1:57  670+ → 2,110 chunks, flat memory
  outro: { start: 3510, duration: 330 }, //    1:57–2:08  complexity was the enemy
} as const;

export const TOTAL_DURATION = 3840; // 128s... contiguous sum below
// hook 150 + pipeline 540 + cause 600 + fix 540 + memory 540 + constants 600 + payoff 540 + outro 330 = 3840

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
